import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

interface FormErrorComponentProps {
  message: string;
}

const ErrorComponent = (props: FormErrorComponentProps) => {
  const { message } = props;
  return (
    <Alert severity="error" sx={{ mb: 3 }}>
      <AlertTitle>Request Has Failed</AlertTitle>
      {message}
    </Alert>
  );
};

export default ErrorComponent;
